import React, { useContext, useEffect, useRef, useState } from "react";
import { backIncstance, detectUserAgent, formatToKoreanWon } from "../../utils/commonFunctions";
import { MyContext } from "../../context/MyContext";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

/**
 * 결제 오픈시 필요한 소스
 */
const URLS = {
  GET_LIST: process.env.REACT_APP_PRODUCT_LIST,
  // GET_LIST: process.env.REACT_APP_MORE_PRODUCT_LIST,
  REQUEST_ORDER: process.env.REACT_APP_MYPAGE_GENERATE_ORDER_LIST,
  CHECK_ORDER: process.env.REACT_APP_MYPAGE_ORDER_CHECK,
  CHECK_USER: process.env.REACT_APP_VERIFY_USER,
  VERIFY_LINK: process.env.REACT_APP_DONGA_VARIFY
}
const TITLE = 'd라이브러리에서 이과력을 높여요.'
const DESCRIPTION = `과학의 호기심부터 탐구력까지,\n 모든 것을 한번에 해결하고 관리하세요! 🤓`

const BENEFITS = [
  {
    HIGHLIGHT: '📰 6만 건',
    REST: null,
    NAME: `의 과학 기사 무제한 열람`,
    COLOR: 'rgba(12, 167, 255, 1)'
  },
  {
    HIGHLIGHT: '📚 1,200권',
    REST: null,
    NAME: `‍ 이상의 모든 매체의 e매거진 제공`,
    COLOR: 'rgba(34, 91, 239, 1)'
  },
  {
    HIGHLIGHT: null,
    REST: null,
    NAME: `‍🎓 교과 및 진로 연계 정보 제공`,
    COLOR: 'rgba(68, 120, 255, 1)'
  },

  {
    HIGHLIGHT: null,
    REST: null,
    NAME: `🤖 어린이 학습만화 ‘어과동 코믹스’ 단독 연재`,
    COLOR: 'rgba(98, 35, 255, 1)'
  },
  {
    HIGHLIGHT: ` 200종 `,
    REST: `선 출간`,
    NAME: `📖 동아사이언스의 과학 교양 단행본 ‘과학동아북스’`,
    COLOR: 'rgba(85, 41, 194, 1)'
  },
  {
    HIGHLIGHT: null,
    REST: null,
    NAME: `과학탐구 AI 솔루션 ‘과학동아AiR’ 제공`,
    COLOR: 'rgba(252, 35, 230, 1)'
  }
]
// 기본 요금제
const DEFAULT = [
  {
    item_id: "XbFpTpGC",
    name: "d라이브러리 All 패스 1개월",
    discount_price: null,
    price: 17900,
    discount_ratio: null,
    url: process.env.REACT_APP_ALL_PASS_1_MONTH
  },
  {
    item_id: "e5od6kq9",
    name: "d라이브러리 All 패스 6개월",
    discount_price: 89500,
    price: 107400,
    discount_ratio: 0.17,
    url: process.env.REACT_APP_ALL_PASS_6_MONTH
  },
  {
    item_id: "orXHAIQq",
    name: "d라이브러리 All 패스 1년",
    discount_price: 161000,
    price: 214800,
    discount_ratio: 0.25,
    url: process.env.REACT_APP_ALL_PASS_1_YEAR
  },
  {
    item_id: "zk8soILc",
    name: "d라이브러리 All 패스 1년 (교사전용)",
    discount_price: 144900,
    price: 214800,
    discount_ratio: 0.32,
    url: process.env.REACT_APP_ALL_PASS_TEACHER
  },
  {
    item_id: "8mXkdQlk",
    name: "d라이브러리 Basic 패스 1개월",
    discount_price: null,
    price: 5900,
    discount_ratio: null,
    url: process.env.REACT_APP_BASIC_1_MONTH
  },
  {
    item_id: "o94R3f94",
    name: "d라이브러리 Basic 패스 6개월",
    discount_price: 29500,
    price: 35400,
    discount_ratio: 0.17,
    url: process.env.REACT_APP_BASIC_6_MONTH
  },
  {
    item_id: "6pCIYkjm",
    name: "d라이브러리 Basic 패스 1년",
    discount_price: 53000,
    price: 70800,
    discount_ratio: 0.25,
    url: process.env.REACT_APP_BASIC_1_YEAR
  },
  {
    item_id: "SOl0byR3",
    name: "d라이브러리 Basic 패스 1년 (교사전용)",
    discount_price: 47700,
    price: 70800,
    discount_ratio: 0.32,
    url: process.env.REACT_APP_BASIC_TEACHER
  }
];


const ABOUT = [
  {
    NAME: '튜터(Q&A)',
    COLOR: 'rgba(134, 65, 246, 1)',
    DESCRIPTION: '질문을 하면, 과학 기사를 바탕으로 정학하게 요약, 설명, 참고자료도 찾아줘요.',
    DETAIL: '1000개(30일)'
  },
  {
    NAME: '소크라테스(모의면접)',
    COLOR: 'rgba(79, 116, 249, 1)',
    DESCRIPTION: '활동 보고서 등을 업로드하면 나만의 맞춤형 모의 면접을 볼 수 있어요.',
    DETAIL: '50회(30일)'
  },
  {
    NAME: '평가 리포트 제공',
    COLOR: 'rgba(69, 91, 168, 1)',
    DESCRIPTION: '답변 내용을 분석하여 과학적 소양 역량에 대한 피드백을 받아볼 수 있어요.',
    DETAIL: null
  },
]

/**
 * 결제 요청 순서
 * 1. 본인 인증 확인
 * 2. 주문 생성
 * 3. 주문 생성 확인
 * 4. 응답으로 payUrl 연결
 */

const POLLING_INTERVAL = 1000; // 1초 간격으로 폴링
const POLLING_DURATION = 60000; // 60초 동안 폴링

const Products = props => {

  const { setAlertSetting, setAlertModal, clearState, user, isMobile } = useContext(MyContext)
  const navigation = useNavigate()

  const containerRef = useRef(null);

  const [productList, setProductList] = useState([...DEFAULT])
  const [selectedItem, setSelectedItem] = useState({
    item_id: null,
    name: null,
    price: 0,
    discount_price: 0,
    discount_ratio: 0,
  })
  const [isAgree, setIsAgree] = useState(false) // 환불규정 동의 유무
  /**
 *
 * @param {target url} target
 * @param {response data} response
 */
  const handleError = (target, response) => {
    const code = response.code;
    const isVerify = target.includes(URLS.CHECK_USER);

    const text =
      (code === 401 && isVerify) ? '본인 인증 후 구매 가능힙니다.\n 회원정보수정에서 본인인증을 진행해주세요.'
        : (code === 401 && !isVerify) ? '로그인이 필요합니다.\n'
          : code === 409 ? '동일한 상품에 대한 구매내역이 있습니다.\n 구매내역으로 이동하시겠습니까?'
            : code === 408 ? '결제 시간이 초과되었습니다.\n 다시 시도해주세요.'
              : '결제에 실패했습니다.\n 다시 시도해주세요.';

    const confirmText =
      (code === 401 && isVerify) ? '인증하러 가기'
        : (code === 409 || (code === 401 && !isVerify)) ? '이동하기'
          : '닫기';

    setAlertSetting(prev => {
      const newAlertSetting = {
        ...prev,
        alertTxt: text,
        double: (code === 401 || code === 409) ? true : false,
        btnTxt: confirmText,
      };

      if (code !== 404) {
        newAlertSetting.onConfirm = () => {
          clearState();
          if (code === 401) {
            if (isVerify) {
              window.open(`${URLS.VERIFY_LINK}/member/info`);
            } else {
              navigation('/login', { state: { from_chat: null, his_cnt: 0, is_writed: false, is_completed: false } });
            }
            return
          } else if (code === 409) {
            navigation('/order-list');
            return
          }
        };
      }

      return newAlertSetting;
    });
  };

  const touchAPI = async (method, url, data) => {

    try {
      const response = await backIncstance(method, url, data)
      if (response.status !== 200) {
        if (user.id) {
          handleError(url, response)
        }
        return
      }
      return response
    } catch (err) {
      setAlertSetting(prev => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: '닫기'
      }));
    } finally {
      setFetching(false)
    }

  }
  const [fetching, setFetching] = useState(false);
  /**
   * 주문 완료 후 polling 중단
   * 서비스 닫고 결제창만 켜있을경ㄹ우 /check 가 안되어서 backend 추가되면
   * @param {} method
   * @param {*} url
   * @param {*} data
   * @returns
   */

  const pollingAPI = async (method, url, data, paymentWindow) => {

    const startTime = Date.now();
    let isPolling = true;

    const poll = async () => {
      if (!isPolling || (paymentWindow && paymentWindow.closed)) {
        isPolling = false;
        setFetching(false);
        paymentRef.current = false
        return; // 결제 창이 닫혔거나 폴링 중단 조건이 만족되면 종료
      }
      try {
        const response = await backIncstance(method, url, data);

        // 408 에러 발생 시 폴링 계속 진행
        if (response.status === 408) {
          if ((Date.now() - startTime) < POLLING_DURATION) {
            setTimeout(poll, POLLING_INTERVAL);
          } else {
            setAlertSetting(prev => ({
              ...prev,
              alertTxt: `결제 시간이 초과되었습니다.\n다시 시도해주세요.`,
              btnTxt: '닫기'
            }));
            isPolling = false;
          }
          return;
        }

        if (response.status !== 200 && !url.includes(URLS.REQUEST_ORDER)) {
          handleError(url, response);
          paymentRef.current = false
          isPolling = false;
          return;
        }

        const responseData = await response.json();

        if (!responseData.detail) {
          isPolling = false;
          if (paymentWindow) {
            paymentWindow.close();
            paymentRef.current = false
          }
          setAlertSetting(prev => ({
            ...prev,
            alertTxt: `결제가 완료되었습니다.\n 구매내역 페이지로 이동하겠습니까?`,
            double: true,
            btnTxt: '이동하기',
            onConfirm: () => {
              if (typeof prev.onConfirm === 'function') {
                prev.onConfirm();
              }
              navigation('/order-list');
            }
          }));
          return responseData;
        } else {
          if ((Date.now() - startTime) < POLLING_DURATION) {
            setTimeout(poll, POLLING_INTERVAL);
          } else {
            paymentRef.current = false
            setAlertSetting(prev => ({
              ...prev,
              alertTxt: `결제가 완료되지 않았습니다.\n다시 시도해주세요.`,
              btnTxt: '닫기'
            }));
            isPolling = false;
          }
          return responseData;
        }

      } catch (err) {
        setAlertSetting(prev => ({
          ...prev,
          alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
          btnTxt: '닫기'
        }));
      } finally {
        setFetching(false);

      }
    };

    return poll();
  };

  const paymentRef = useRef(false)
  /**
   * 본인 인증 및 구매 진행, 동아사이언스 패밀리 사이트 결제로 주석처리
   * @param {event obj} e
   * @param {clicked item} item
   * @returns
   */
  // const handlePurchase = async (e, item) => {

  //   e.stopPropagation();


  //   setSelectedItem(item)
  //   /** 규정 미 동의시 진행 불가 */
  //   if (!isAgree) {
  //     setAlertSetting(prev => ({
  //       ...prev,
  //       alertTxt: '상품 구매 규정 동의 체크 후 진행해주세요.'
  //     }))
  //     return
  //   }
  //   /** 본인 인증 여부 체크, 미이행시 진행 불가 */

  //   const response = await touchAPI('GET', URLS.CHECK_USER)
  //   if (response === undefined) {
  //     const isLogin = user.id ? true : false;
  //     setAlertSetting(prev => ({
  //       ...prev,
  //       alertTxt: isLogin ? `본인 인증이 필요합니다.\n 본인 인증 하러가기` : `로그인이 필요합니다.\n 로그인 하러가기`,
  //       double: true,
  //       btnTxt: isLogin ? '인증하러 가기' : '이동하기',
  //       onConfirm: () => {
  //         if (typeof prev.onConfirm === 'function') {
  //           prev.onConfirm();
  //         }
  //         if (isLogin) {
  //           window.open(`${URLS.VERIFY_LINK}/member/info`);
  //         } else {
  //           navigation('/login', { state: { from_chat: null, is_writed: false, is_completed: false, his_cnt: 0 } })
  //         }
  //       }
  //     }));
  //     return
  //   } else if (response) {
  //     if (fetching) return
  //     setFetching(true)
  //     const resData = await response.json();
  //     const device = detectUserAgent();
  //     const reqData = {
  //       item_id: item.item_id,
  //       order_env: device,
  //       order_agree: isAgree
  //     }
  //     if (resData.code === 200) {
  //       /** 결제 요청 API */
  //       const orderRes = await touchAPI('POST', URLS.REQUEST_ORDER, reqData)
  //       // if (orderRes && orderRes.status === 200) {
  //       if (orderRes.status === 200) {
  //         window.open(item.url)
  //         const orderResData = await orderRes.json();
  //         if (orderResData.pay_url) {
  //           // 요청 부분
  //           if (paymentWindow) {
  //             const checkReq = `?order_no=${orderResData.order_no}`;
  //             paymentRef.current = true
  //             const checkRes = await pollingAPI('GET', URLS.CHECK_ORDER, checkReq, paymentWindow);
  //             // if (checkRes && checkRes.code === 200) {
  //             //   if (paymentWindow) {
  //             //     paymentWindow.close();
  //             //   }
  //             //   setAlertSetting(prev => ({
  //             //     ...prev,
  //             //     alertTxt: `결제가 완료되었습니다.\n 구매내역 페이지로 이동하겠습니까?`,
  //             //     double: true,
  //             //     btnTxt: '이동하기',
  //             //     onConfirm: () => {
  //             //       if (typeof prev.onConfirm === 'function') {
  //             //         prev.onConfirm();
  //             //       }
  //             //       navigation('/order-list');
  //             //     }
  //             //   }));
  //             // } else if (checkRes && checkRes.code === 408 && !fetching) {
  //             //   paymentWindow.close()
  //             //   setAlertSetting(prev => ({
  //             //     ...prev,
  //             //     alertTxt: `결제에 실패하였습니다.\n 다시 시도해주세요.`,
  //             //     btnTxt: '닫기',
  //             //   }));
  //             // }
  //           } else {
  //             paymentRef.current = false
  //           }
  //         }
  //       }

  //     } else if (resData.code === 401) {
  //       setAlertSetting(prev => ({
  //         ...prev,
  //         alertTxt: `본인 인증이 필요합니다.\n 본인 인증 하러가기`,
  //         double: true,
  //         btnTxt: '인증하러 가기',
  //         onConfirm: () => {
  //           if (typeof prev.onConfirm === 'function') {
  //             prev.onConfirm();
  //           }
  //           window.open(`${URLS.VERIFY_LINK}/member/info`);
  //         }
  //       }));

  //       return
  //     }

  //   } else {
  //     setAlertSetting(prev => ({
  //       ...prev,
  //       alertTxt: "다시 시도해주세요.",
  //       btnTxt: '닫기'
  //     }))
  //   }
  // }
  const handlePurchase = async (e, item) => {

    e.stopPropagation();
    window.open(item.url)

  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'  // 'smooth'는 스크롤이 부드럽게 이동하도록 합니다. 필요에 따라 'auto'로 변경 가능
    });
    const getData = async () => {
      try {
        const response = await touchAPI('GET', URLS.GET_LIST);
        const resData = await response.json();
        if (resData.item_list) {
          setProductList(resData.item_list);
        }
      } catch (error) {
        setAlertSetting(prev => ({
          ...prev,
          alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
          btnTxt: '닫기'
        }));
      }
    };

    getData();
  }, []);

  useEffect(() => {
    if (!isAgree) {
      setSelectedItem({
        item_id: null,
        name: null,
        price: 0,
        discount_price: 0,
        discount_ratio: 0,
      })
    }
  }, [isAgree])

  return (
    <Style>
      <div className="ctn-wrp flx-box st-wrp product-list" ref={containerRef}>
        <div
          className="product-list__title setting-title"
          style={{ padding: 0 }}
        >
          <p className="product-title">{TITLE}</p>
          <p className="product-description">{DESCRIPTION}</p>
        </div>
        <div className="product-list__wrapper top">
          {
            BENEFITS?.reduce((rows, item, idx) => {
              if (idx % 2 === 0) {
                rows.push([item]);
              } else {
                rows[rows.length - 1].push(item);
              }
              return rows;
            }, []).map((row, rowIndex) => {
              return (
                <div className={`product-row ${rowIndex > 1 ? '' : 'flx-box'}`} key={row}>
                  {row.map((item, itemIndex) => (
                    <div
                      className={`product-item flx-box ${selectedItem.name === item.NAME ? 'selected' : ''}`}
                      key={item.NAME}
                      style={
                        // { borderColor: COLORS[(rowIndex * 2 + itemIndex) % COLORS.length] }
                        { borderColor: item.COLOR }
                      }
                    >
                      {
                        (item.HIGHLIGHT && (rowIndex < 2)) &&
                        <p className="highlight-word">{item.HIGHLIGHT}</p>
                      }
                      <p
                        className={`item-name ${item.COLOR === BENEFITS[5].COLOR ? 'responsive-box' : ''}`}>
                        {
                          item.COLOR === BENEFITS[5].COLOR
                          &&
                          // <img src={Pass} alt="" />
                          <div className="pass-wrapper">
                            <span
                            >All 패스 ONLY
                            </span>
                          </div>
                        }
                        <span
                          style={
                            item.COLOR === BENEFITS[5].COLOR ?
                              {
                                display: 'flex',
                                alignItems: 'center',
                                marginLeft: '5px'
                              }
                              :
                              null
                          }

                        >{item.NAME}</span>
                        {
                          (item.HIGHLIGHT && (rowIndex >= 2)) &&
                          <>
                            <p
                              style={{
                                display: 'contents'
                              }}
                              className="highlight-word">{item.HIGHLIGHT}</p>
                            <p
                              style={{
                                display: 'contents'
                              }}>{item.REST}</p>

                          </>
                        }
                      </p>
                      {/* <p className="item-detail">{item.DETAIL}</p> */}
                    </div>
                  ))}
                </div>
              )
            })
          }
          <div className="product-about">
            <p className="about-title"><span>과학동아AiR</span><span>란?</span></p>
            <div className="about-detail">
              {
                ABOUT.map(item => (
                  <div className="responsive-box">
                    <div style={{ background: item.COLOR }} className="name">{item.NAME}</div>
                    <div className="description">{item.DETAIL ? <p className="bold-txt">{`${item.DETAIL}  `}</p> : null}<p>{item.DESCRIPTION}</p></div>
                  </div>
                ))
              }
            </div>
          </div>
        </div >

        <div className='product-details product-list__wrapper middle'>
          <div className="inner">
            {/* <div className="flx-box agreement">
            <label className="custom-checkbox crs-btn">
              <input
                type="checkbox"
                checked={isAgree}
                onChange={(e) => setIsAgree(e.target.checked)}
              />
              <span className="checkmark"></span>
            </label>
            <p>상품의 가격, 기간 및 환불규정을 확인하였으며 동의합니다.</p>
          </div> */}
            {/* <div className="flx-box"> */}
            <div className="">
              {/* {
              productList?.map((proItem, proIdx) => {
                return (
                  <div className='content' key={proItem.name} >
                    <div className="title">{proItem.name ? proItem.name : '상품명'}</div>
                    <div className="price"
                    ><p className="origin-price">{proItem?.discount_price ? formatToKoreanWon(proItem.price) + '원' : ''}</p>
                      <div className="flx-box">
                        <p className="discount-rate">
                          {proItem?.discount_price > 0 ? (
                            `${((proItem.price - proItem.discount_price) / proItem.price * 100).toFixed(0)}%`
                          ) : null}
                        </p>
                        <p className="final-price">{proItem?.discount_price ? formatToKoreanWon(proItem.discount_price) : formatToKoreanWon(proItem.price)}원</p></div>
                    </div>
                    <div className="action"><button className={`action crs-btn ${isAgree ? 'active' : 'inactive'}`} onClick={(e) => !fetching && handlePurchase(e, proItem)}>바로구매</button></div>
                  </div>
                )
              })
            } */}
              {
                (() => {
                  const pairedProducts = [];
                  for (let i = 0; i < productList.length; i += 2) {
                    const firstProduct = productList[i];
                    const secondProduct = productList[i + 1];

                    pairedProducts.push(
                      <div className="content-pair flx-box" key={i}>
                        <div className="content" key={firstProduct.name}>
                          <div className="title">{firstProduct.name || '상품명'}</div>
                          <div className="price">
                            <p className="origin-price">{firstProduct?.discount_price ? formatToKoreanWon(firstProduct.price) + '원' : ''}</p>
                            <div className="flx-box">
                              <p className="discount-rate">
                                {firstProduct?.discount_ratio ? (
                                  `${(firstProduct.discount_ratio * 100).toFixed(0)}%`
                                ) : null}
                              </p>
                              <p className="final-price">
                                {firstProduct?.discount_price ? formatToKoreanWon(firstProduct.discount_price) : formatToKoreanWon(firstProduct.price)}원
                              </p>
                            </div>
                          </div>
                          <div className="action">
                            <button className={`action crs-btn active`} onClick={(e) => !fetching && handlePurchase(e, firstProduct)}>상품 상세보기</button>
                          </div>
                        </div>

                        {/* 두 번째 product가 있을 때만 렌더링 */}
                        {secondProduct && (
                          <div className="content" key={secondProduct.name}>
                            <div className="title">{secondProduct.name || '상품명'}</div>
                            <div className="price">
                              <p className="origin-price">{secondProduct?.price ? formatToKoreanWon(secondProduct.price) + '원' : ''}</p>
                              <div className="flx-box">
                                <p className="discount-rate">
                                  {secondProduct?.discount_ratio ? (
                                    `${(secondProduct.discount_ratio * 100).toFixed(0)}%`
                                  ) : null}
                                </p>
                                <p className="final-price">
                                  {secondProduct?.discount_price ? formatToKoreanWon(secondProduct.discount_price) : formatToKoreanWon(secondProduct.price)}원
                                </p>
                              </div>
                            </div>
                            <div className="action">
                              <button className={`action crs-btn active`} onClick={(e) => !fetching && handlePurchase(e, secondProduct)}>상품 상세보기</button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  }
                  return pairedProducts;
                })()
              }
            </div>
          </div>
        </div>

        <div className="product-list__wrapper bottom">
          <p className="title">환불규정 안내</p>
          <p className="description">[d라이브러리 패스 (Basic/All) 환불규정]</p>
          <table className="refund-info">
            <tbody>
              <tr>
                <td className="refund-kind">구매를 하였으나 이용하지 않은 경우</td>
                <td className="refund-detail"><div>결제일로부터 7일 이내</div><div>결제일로부터 7일 이후</div></td>
                <td className="refund-detail">
                  {
                    isMobile ?
                      <div>전액 환불</div>
                      :
                      `전액 환불`
                  }
                </td>
              </tr>
              <tr>
                <td className="refund-kind">이용 이력이 있는 경우</td>
                <td className="refund-detail"><div>1개월 d라이브러리 패스 (Basic/All)</div><div>1개월 초과하는 d라이브러리 패스 (Basic/All)</div></td>
                <td className="refund-detail"><div>환불 불가</div><div>결제대금에서 해지신청일을 포함하는 이용기간(월)에 비례하는 이용대금을 공제한 잔액의 90% 환불<span>예) 6개월 d라이브러리 Basic 패스 구매 후 마지막 사용일이 결제일 기준 40일 경과한 경우, 2개월*5,900원을 공제한 잔액의 90% 환불</span></div></td>
              </tr>
            </tbody>
          </table>
          <div className="ref">
            <p>단, 다음의 경우에는 이용자가 환불을 요청할 수 없습니다.</p>
            <p>- 마지막 이용일 기준 d라이브러리 패스 (Basic/All)의 유효기간이 30일 미만으로 남은 경우</p>
            <p>- 서비스 업데이트를 통한 문제 해결이 가능함에도 회원의 의사로 이를 거부하여 서비스를 이용하지 못하는 경우</p>
          </div>
        </div>
      </div >
    </Style>
  )
}
export default Products;


const Style = styled.div`
@media screen and (min-width: 1024px) {
     height: auto;
}
@media screen and (min-width: 768.99px) and (max-width: 1023.99px) {
    height: auto;

}
    @media screen and (max-width: 768.98px) {
    height: calc(100% - 120px);
  
}
`
